// Sets jQuery on the global scope BEFORE summernote loads.
// This file must be imported before summernote-lite.js.
// ES module evaluation is depth-first: this module's body runs
// before the next sibling import in the parent module.
import $ from 'jquery';

// Polyfill $.now() for Summernote v0.9.0 (removed in jQuery 3.3)
if (!$.now)
{
  ($.now as any) = Date.now;
}

// Polyfill $.nodeName() for Summernote v0.9.0 (removed in jQuery 4.0).
if (!$.nodeName)
{
  ($.nodeName as any) = (elem: Element, name: string) =>
    elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
}

(window as any).$ = $;
(window as any).jQuery = $;
